import { ComponentsProvider } from '@looker/components';
import { BIToastContainer, customLookerTheme } from '@pulsepointinc/bi-components';
import { QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import type { FC, PropsWithChildren } from 'react';
import { useDTCAudienceTaskPolling } from '../hooks/useDTCAudienceTaskPolling';
import { useReportPolling } from '../hooks/useReportPolling';
import { queryClient } from '../lib';
import { AIContextProvider } from './AIProvider';
import { ConditionalSocketConnectionProvider } from './ConditionalSocketConnectionProvider';
import { LookerDashboardProvider } from './LookerDashboardProvider';
import { MaintenanceProvider } from './MaintenanceProvider';
import { PostHogProvider } from './PosthogContextProvider';
import { TourProvider } from './TourProvider';

const ReportPollingWrapper = () => {
  useReportPolling();
  return null;
};

const DTCAudiencePollingWrapper = () => {
  useDTCAudienceTaskPolling();
  return null;
};

export const AppContextProviders: FC<PropsWithChildren> = ({ children }) => (
  <PostHogProvider>
    <QueryClientProvider client={queryClient}>
      <ReportPollingWrapper />
      <DTCAudiencePollingWrapper />
      <ComponentsProvider themeCustomizations={customLookerTheme}>
        <LookerDashboardProvider>
          <ConditionalSocketConnectionProvider>
            <MaintenanceProvider>
              <TourProvider>
                <AIContextProvider>{children}</AIContextProvider>
              </TourProvider>
            </MaintenanceProvider>
            <BIToastContainer />
          </ConditionalSocketConnectionProvider>
        </LookerDashboardProvider>
      </ComponentsProvider>

      {process.env.NODE_ENV === 'development' && (
        <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
      )}
    </QueryClientProvider>
  </PostHogProvider>
);
